<template>
  <div>
    <v-btn small icon @click="handleShowForm">
      <v-icon small>edit</v-icon>
    </v-btn>

    <v-dialog v-model="showModal" max-width="800">
      <v-card v-if="!caseInfo && showModal">
        Loading...
      </v-card>
      <v-card v-else>
        <v-card-title class="headline">Add requested service log item</v-card-title>
        <v-card-text>
          <v-form v-model="isValid" ref="form">
            <number-delta-input v-model="form.quantityChange"
                                label="New quantity"
                                :current-value="currentRequestedQuantity"
                                :min-value="0"
                                :max-value="100"/>
            <date-time-input
              label="Date and time"
              :required="true"
              v-model="form.occurredAt"/>

            <v-text-field
              label="Comment"
              v-model="form.comment"/>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="handleHideForm">Cancel</v-btn>
          <v-btn @click="handleFormSubmit" :loading="requestInProgress" :disabled="!isSubmitEnabled">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import {mapActions} from 'vuex';
  import ServiceSelect from '../../Ui/mcc/ServiceSelect'
  import NumberDeltaInput from '../../Ui/NumberDeltaInput'
  import {notificationService} from '../../../application'
  import {getDefaultRequestedDate} from "./caseServiceLogUtils";
  import DateTimeInput from "../../Ui/DateTimeInput";

  function getDefaultFormData(caseInfo) {
    return {
      quantityChange: 0,
      occurredAt: getDefaultRequestedDate(caseInfo),
      comment: '',
    }
  }

  export default {
    name: 'edit-requested-service-form',
    components: {
      ServiceSelect,
      NumberDeltaInput,
      DateTimeInput
    },
    props: {
      caseId: {
        type: String,
        required: true
      },
      serviceId: {
        type: String,
        required: true
      },
      currentRequestedQuantity: {
        type: Number,
        required: true
      },
      currentExecutedQuantity: {
        type: Number,
        required: true
      },
    },
    data() {
      let caseInfo = this.$store.getters.getCaseInfoById(this.caseId); // computed not active, so copy-paste
      return {
        isValid: false,
        showModal: false,
        form: getDefaultFormData(caseInfo),
        requestInProgress: false,
      }
    },
    computed: {
      isSubmitEnabled() {
        if (this.form.quantityChange === 0 || !this.form.occurredAt) {
          return false
        }

        if (this.$refs.form && !this.$refs.form.validate()) {
          return false
        }

        return true
      },
      caseInfo() {
        let result = this.$store.getters.getCaseInfoById(this.caseId);
        this.form.occurredAt = getDefaultRequestedDate(result);
        return result
      },
      availableServicesForClient() {
        if (!this.caseInfo || !this.caseInfo.response) { // case not loaded yet
          return []
        }

        return this.$store.getters.getClientServices(this.caseInfo.response.clientId);
      },
    },
    mounted() {
      this.fetchCaseByIdIfRequired(this.caseId);
    },
    watch: {
      showModal() {
        if (!this.showModal) {
          this.resetForm()
        }
      }
    },
    methods: {
      ...mapActions({
        addCaseServiceLog: 'addCaseServiceLog',
        fetchCaseByIdIfRequired: 'fetchCaseByIdIfRequired',
      }),
      handleShowForm() {
        this.showModal = true
      },
      handleHideForm() {
        this.showModal = false
      },
      handleFormSubmit() {
        if (!this.isSubmitEnabled) {
          return
        }

        this.requestInProgress = true;
        this
          .addCaseServiceLog({
            caseId: this.caseId,
            serviceId: this.serviceId,
            event: 'ChangeRequested',
            quantityChange: this.form.quantityChange,
            occurredAt: this.form.occurredAt,
            comment: this.form.comment
          })
          .then(() => {
            this.requestInProgress = false;
            notificationService.info('Log record created');
            this.showModal = false
          })
          .catch(e => {
            this.requestInProgress = false;
            notificationService.error('Operation failed');
            throw e
          })
      },
      resetForm() {
        this.form = getDefaultFormData(this.caseInfo)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Sales/case/EditRequestedServiceForm.vue